import React from 'react';
import { trackEvent } from '../lib/analytics';

const HREF = 'https://wa.me/919136843555?text=Hi%20DPOS%20Sales%2C%20I%27m%20interested%20in%20a%20free%20demo.';

export default function WhatsAppButton() {
  return (
    <a
      href={HREF}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with DPOS Sales on WhatsApp"
      onClick={() => trackEvent('whatsapp_click', { source: 'floating_button' })}
      style={{
        position: 'fixed', bottom: 24, right: 24, zIndex: 70,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        width: 56, height: 56, borderRadius: '50%',
        background: '#25d366', boxShadow: '0 6px 20px rgba(0,0,0,0.2)',
        fontSize: 28, textDecoration: 'none',
      }}
    >
      💬
    </a>
  );
}
